import { z } from 'zod';

import { gatewayTypeSchema } from './gatewayType';
import { gatewayPositionSchema, waterstopTypeSchema } from './installationTask';
export const gatewayStatusSchema = z.union([
  z.literal('ok'),
  z.literal('warning'),
  z.literal('error'),
  z.literal('inactive'),
]);

export type Gateway = z.infer<typeof gatewaySchema>;
export const gatewaySchema = z.object({
  gatewayId: z.number(),
  projectId: z.number().nullable(),
  projectName: z.string().nullable().optional(),
  installationId: z.number().nullable(),
  productKey: z.string().nullable(),
  status: gatewayStatusSchema.optional(),
  coordinatesX: z.number().nullable(),
  coordinatesY: z.number().nullable(),
  position: gatewayPositionSchema.nullable().optional(),
  isWaterguard: z.boolean().optional(),
  waterstopType: waterstopTypeSchema.nullable().optional(),
  gatewayType: gatewayTypeSchema.nullable().optional(),
  comment: z.string().nullable().optional(),
  lastDataReceived: z.string().nullable().optional(),
});
